// main.js 
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import VueKeepScrollPosition from 'vue-keep-scroll-position'
import { sync  } from 'vuex-router-sync';



Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VueKeepScrollPosition);

var VueTouch = require('./vue-touch.js');
Vue.use(VueTouch);

import Element from 'element-ui';
import  'element-ui/lib/theme-default/index.css';
Vue.use(Element)

import store from './components/store/store';

import 'jquery';
import velocity from 'velocity-animate';
import '../node_modules/velocity-animate/velocity.ui.js';



// components
const App = require('./components/app');
const Projects = require('./components/projects');
const Page = require('./components/page');
const Index = require('./components/index');
const TestTouch = require('./components/testtouch');
const Clients = require('./components/clients');


// prevent scrolling with arrow keys, mainly for Firefox
window.addEventListener("keydown", function(e) {
    // space and arrow keys
    if([32, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
        e.preventDefault();
    }
}, false);

// scroll behaviour for routes
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}
    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position
  }
}

// @TODO place in external file
const routes = [
    { path: '/testtouchevents', component: TestTouch, name: 'testtouch', meta: { scrollToTop: true  }  },
    { path: '/', component: App, name: 'app', children : [

        { path: '/', redirect: { name: 'project', params : { slug : 'startseite' }  } },
        { path: '/projekte', component: Projects, name: 'projects', meta: { scrollToTop: true  }  },
        { path: '/projekte/:slug', component: Projects, name: 'project', meta: { scrollToTop: true  }  },
        { path: '/projekte/:slug/:index', component: Projects, name: 'project-slide', meta: { scrollToTop: true  }  },
        { path: '/start', component: Projects, name: 'start'  },
        { path: '/clients', component: Clients, name: 'clients', meta : { scrollToTop : true }  },
        { path: '/index', component: Index, name: 'index', meta: { scrollToTop: true  }  },
        { path: '/index/client/:clientSlug', component: Index, name: 'index-client', meta: { scrollToTop: true  }  },
        { path: '/index/:category', component: Index, name: 'index-category', meta: { scrollToTop: true  }  },
        { path: '/seite/:pageslug', 
            component: Page, 
            name: 'page', 
            meta: { scrollToTop: true  },
            beforeEnter : function(to, from, next) {
                console.log('route changed to page' + Date.now());
                next();
            }
        },
    ]  
    },

];


// configure router
var router = new VueRouter({
    mode: 'history',
    base: '/',
    scrollBehavior,
    routes : routes,
});



sync(store, router);

// load data
console.log('Loading data')

console.log("Loading config");
Vue.http.get('/static/config/config.json').then((response) => {
    store.commit('setConfig', response.body.config);

}, (response) => {
    console.error("error loading data");
});

console.log("Loading clients");
Vue.http.get('/static/clients.json').then((response) => {

    store.commit('setClients', response.body.clientCategories);

}, (response) => {
    console.error("error loading data");
});

console.log("Loading categories");
Vue.http.get('/static/categories.json').then((response) => {
     store.commit('setCategories', response.body.categories);

}, (response) => {
    console.error("error loading data");
});

console.log("Loading projects");
Vue.http.get('/static/projects-new.json').then((response) => {
    store.commit('setProjects', response.body.projects);
    const app = new Vue({ router }).$mount('#app');

}, (response) => {
    console.error("error loading projects");
});



export default router;



// WEBPACK FOOTER //
// ./src/main.js